/* eslint-disable */
import axios from 'axios'
import * as Sentry from '@sentry/react'
import { LocalFind, LocalInsert } from '@weblite/persist'
import { createCallbackManager } from '$func/callbacks'

const CLOCK_CHECK = 'clock-check'
const CLOCK_OFFSET = 'time-offset'
const TIME_ZONE = 'time-zone'
const MINUTE_MS = 60000

export const timeOffsetChangeCallbackManager = createCallbackManager()

const options = {
  // checkInterval: 2 * 60 * 60 * 1000, // 2 hours
  timeServer: import.meta.env.VITE_TIME_SERVER,
  tolerance: MINUTE_MS,
  dstStr: 'iran daylight',
}

const getServerOffset = async () => {
  if (!options.timeServer) return 0

  const { data } = await axios.get(options.timeServer)
  analite('TIME_ZONE_SERVER_OFFSET_DATA', {
    DATA: `${data}`,
  })

  if (!data) return Date.now()
  return Date.now() - +data * 1000
}

export const getOffset = () => {
  return +(LocalFind(CLOCK_OFFSET) || 0)
}

export const dateWithOffset = () => {
  return Date.now() - +(LocalFind(CLOCK_OFFSET) || 0)
}

export const hasClockOffset = async () => {
  // in milliseconds
  const offset = await getServerOffset()
  const hasOffset = Math.abs(offset) > options.tolerance

  LocalInsert(CLOCK_OFFSET, hasOffset ? offset.toString() : '0')

  if (hasOffset) {
    Sentry.setTag('clock.offset', offset)
  }

  const dst = new Date().toString().toLowerCase().includes(options.dstStr)
  if (dst) Sentry.setTag('clock.dst', true)

  analite('TIME_ZONE_SET_OFFSET', {
    OFFSET: offset,
    CLOCK_OFFSET: hasOffset ? offset.toString() : '0',
    HAS_OFFSET: dst || hasOffset,
  })

  return { hasOffset: dst || hasOffset, offset: offset }
}

export const checkTimeOffset = async () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const prevOffset = Number(LocalFind(CLOCK_OFFSET))

  analite('TIME_ZONE_GET_TIME_ZONE', {
    TIME_ZONE: timeZone,
  })

  analite('TIME_ZONE_GET_CLOCK_OFFSET', {
    CLOCK_OFFSET: LocalFind(CLOCK_OFFSET),
  })

  const { hasOffset, offset } = await hasClockOffset()
  if (Math.abs(offset - prevOffset) > options.tolerance)
    timeOffsetChangeCallbackManager.runCallbacks()

  LocalInsert(TIME_ZONE, timeZone)
  LocalInsert(CLOCK_CHECK, Date.now().toString())

  return hasOffset
}
